export default {
	bizInspectCalWarn: {
		// título y botones
		alarmRecord: 'Registro de Alarma',
		alarmStatistics: 'Estadísticas de Alarma',
		export: 'Exportar',
		ignore: 'Ignorar',
		confirm: 'Confirmar',
		details: 'Detalles',
		generateReport: 'Generar Informe',
		cancel: 'Cancelar',
		ok: 'Aceptar',

		// etiquetas de formulario
		deviceName: 'Nombre del Dispositivo',
		deviceNo: 'Número de Dispositivo',
		orgName: 'Departamento',
		status: 'Estado',
		alarmTime: 'Tiempo de Alarma',
		alarmLevel: 'Nivel de Alarma',
		alarmCount: 'Conteo de Alarmas',
		alarmTitle: 'Título de Alarma',
		startTime: 'Hora de Inicio',
		endTime: 'Hora de Fin',
		handleStatus: 'Estado de Manejo',
		type: 'Tipo de Alarma',

		// placeholder de formulario
		selectProcessor: 'Seleccionar Procesador',
		processSuggestion: 'Sugerencia de Proceso',
		selectAlarmType: 'Seleccionar Tipo de Alarma',
		selectAlarmLevel: 'Seleccionar Nivel de Alarma',
		selectHandleStatus: 'Seleccionar Estado de Manejo',

		// títulos de diálogo
		selectTimeRange: 'Seleccionar Rango de Tiempo',
		confirmAlarm: 'Confirmar Alarma',
		generateReportTitle: 'Generar Informe',

		// mensajes
		confirmIgnore: '¿Ignorar esta alarma?',
		reportGenerating: 'Generando informe, espere...',
		reportSuccess: '¡Informe generado exitosamente!',
		reportFailed: 'Error al generar el informe, inténtelo de nuevo más tarde',
		reportTimeout: 'La generación del informe tarda más, actualice la página más tarde',
		operationSuccess: 'Operación exitosa',
		requiredField: 'El campo obligatorio no puede estar vacío',

		// texto de estado
		running: 'Funcionando',
		stop: 'Detenido',
		offline: 'Desconectado',
		normal: 'Normal',
		general: 'General',
		medium: 'Medio',
		severe: 'Severo',

		// otros
		gridLayout: 'Diseño de Cuadrícula',
		parameterType: 'Tipo de Parámetro',
		parameterValue: 'Valor de Parámetro',
		parameterDesc: 'Descripción de Parámetro',

		// diálogo de estadísticas de alarma
		alarmStatisticsTitle: 'Estadísticas de Alarma',
		filterConditions: 'Condiciones de Filtro',
		department: 'Departamento',
		dateRange: 'Rango de Fechas',
		to: 'A',
		startDate: 'Fecha de Inicio',
		endDate: 'Fecha de Fin',
		query: 'Consultar',
		reset: 'Restablecer',
		statisticsResult: 'Resultado de Estadísticas',
		prealarmTotal: 'Total de Pre-alarmas',
		diagnosisTotal: 'Total de Diagnósticos',
		incorrectAlarm: 'Alarma Incorrecta',
		correctAlarm: 'Alarma Correcta',
		incorrectDiagnosis: 'Diagnóstico Incorrecto',
		correctDiagnosis: 'Diagnóstico Correcto',
		unconfirmedAlarm: 'Alarma Sin Revisar',
		unconfirmedDiagnosis: 'Diagnóstico Sin Revisar',
		noData: 'Sin Datos',
		prealarmStatistics: 'Estadísticas de Pre-alarmas',
		diagnosisStatistics: 'Estadísticas de Diagnóstico',

		// componente list-warn
		deviceInfoPanel: 'Panel de Información del Dispositivo',
		unknownDevice: 'Dispositivo Desconocido',
		pointList: 'Lista de Puntos',
		alarmInfo: 'Información de Alarma',
		alarmType: 'Tipo de Alarma',
		content: 'Contenido',
		currentPoint: 'Punto Actual',
		markFilter: 'Filtro de Marca',
		filterDisplay: 'Mostrar Filtro',
		showAll: 'Mostrar Todo',
		batchConfirm: 'Confirmación Masiva',
		batchIgnore: 'Ignorar Masivamente',
		batchDelete: 'Eliminar Masivamente',
		alarmId: 'ID de Alarma',
		push: 'Enviar',
		eigenValue: 'Valor Eigen',
		referenceValue: 'Valor de Referencia',
		actualValue: 'Valor Real',
		aiModelNote: 'Generado por modelo AI, solo para referencia',
		modelConfig: 'Configuración del Modelo',
		processSuggestionInput: 'Entrada de Sugerencia de Proceso',
		pleaseInputSuggestion: 'Por favor ingrese sugerencia de proceso',
		diagnose: 'Diagnosticar',
		configure: 'Configurar',
		delete: 'Eliminar',
		review: 'Revisar',
		reviewResult: 'Resultado de Revisión',
		diagnoseCorrect: 'Diagnóstico Correcto',
		ignoreSuccess: 'Ignorado exitosamente',
		confirmSuccess: 'Confirmado exitosamente',
		configSuccess: 'Configurado exitosamente',
		noConfigFound: 'No se encontró configuración',
		noImage: 'Sin Imagen',
		prompt: 'Aviso',
		suggestion: 'Sugerencia'
	}
}
